import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getCurrentUser } from '../firebase/auth';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    // Give Firebase Auth a moment to restore the session
    const checkAuth = async () => {
      try {
        const currentUser = getCurrentUser();
        if (currentUser) {
          setIsCheckingAuth(false);
          return;
        }
        
        // Wait a bit for auth state to be restored
        setTimeout(() => {
          setIsCheckingAuth(false);
        }, 1000);
      } catch (error) {
        console.error('ProtectedRoute: Error checking auth:', error);
        setIsCheckingAuth(false);
      }
    };

    if (!user) {
      checkAuth();
    } else {
      setIsCheckingAuth(false);
    }
  }, [user]);

  if (isCheckingAuth) {
    return <LoadingSpinner />;
  }

  if (!user) {
    // Store the current location so we can redirect back after login/register
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
